// ##############################
// // // LoginPage view styles
// #############################

import {
  container,
  cardTitle,
  cardLink
} from "assets/jss/material-dashboard-pro-react.jsx";

const loginPageStyle = theme => ({
  loginPage: {
    minHeight: "100vh",
    width: "100%",
    overflowX: "hidden",
    overflowY: "auto",
    padding: "80px 24px 40px",
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      padding: "56px 18px 32px"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "32px 12px 24px"
    }
  },
  loginGrid: {
    minHeight: "calc(100vh - 120px)",
    [theme.breakpoints.down("sm")]: {
      minHeight: "auto",
      margin: "0 !important",
      width: "100% !important"
    }
  },
  loginSpacer: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  loginFormColumn: {
    maxWidth: "430px",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "430px"
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
      flexBasis: "100%",
      paddingLeft: "0 !important",
      paddingRight: "0 !important"
    }
  },
  loginFormBody: {
    width: "100%",
    boxSizing: "border-box",
    padding: "24px 24px 16px",
    [theme.breakpoints.down("xs")]: {
      padding: "20px 14px 12px"
    }
  },
  loginTitleWrap: {
    margin: "80px 0 40px",
    [theme.breakpoints.down("sm")]: {
      margin: "24px 0 28px"
    },
    [theme.breakpoints.down("xs")]: {
      margin: "8px 0 22px"
    }
  },
  container: {
    ...container,
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px"
    }
  },
  cardTitle: {
    ...cardTitle,
    color: "#000000",    
    fontWeight: "400",
    textAlign: "center",
    marginBottom: "15px"
  },
  cardLink: {
    ...cardLink,           
    fontWeight: "400",
    textAlign: "end",
    marginTop: "10px",
    marginBottom: "10px"
  },
  textCenter: {
    textAlign: "center"
  },
  justifyContentCenter: {
    justifyContent: "center !important",
    flexDirection: "column"
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: "#FFFFFF"
    },
    marginLeft: "5px",
    marginRight: "5px"
  },
  inputAdornment: {
    marginRight: "18px"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  cardHeader: {
    marginBottom: "20px"
  },
  socialLine: {
    padding: "0.9375rem 0"
  }
});

export default loginPageStyle;
